export const Logo = ({ dark = false, size = 34 }) => (
    <span className="flex items-center gap-2.5" data-testid="logo">
        <span
            className={`ring-logo ${dark ? "on-dark" : ""}`}
            style={{ width: size, height: size }}
        />
        <span className={`text-lg font-extrabold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
            Digital<span className="gradient-text"> Circle</span>
        </span>
    </span>
);
